export const en = {
    static: {
        taskActions: {
            pass: 'Agree',
            back: 'Reject',
            refuse: 'Veto',
            more: 'More',
            viewLog: 'View Log',
            viewFlowChart: 'View FlowChart',
            viewBizlog: 'Approval Log'
        },
        title: 'Approval confirmation',
        inputLabel: 'Approval comments',
        inputHolder: 'Please enter an approval opinion',
        selectActivity: 'Please select approve note',
        addSignee: 'Add signee',
        footOk: 'Ok',
        footCancel: 'Cancel',
        assignee: {
            title: 'Select Operator',
            cancelAssign: 'Cancel to operate.',
            noAssignee: 'Please select at least one approver.',
            successAssign: 'Operate successfully.',
            errorAssign: 'Operation failed, please contact the administrator!'
        },
        addsign: {
            title: 'Select signee',
            selectConsultant: 'Please select persons to consult.',
            successConsult: 'Consult successfully.',
            cancelSignUp: 'Cancel to sign up.'
        },
        transfer: {
            title: 'Select transfer person',
            selectHandover: 'Please select transfer persons.',
            successTransfer: 'Tranfer successfully.'
        },
        columnName: {
            name: 'Name',
            code: 'Code',
            department: 'Department',
            organization: 'Organization',
            prcessName: 'Process',
            version: 'Version'
        },
        common: {
            placeHolder: 'Please enter search name'
        },
        submit: {
            selectProcess: 'Select Process',
            noProcess: 'Process has not been selected.'
        },
    },
    cueWords: {
        successClaim: 'Claim successfully.',
        successUnClaim: 'Cancel to claim successfully.',
        successRetrieve: 'Retrieve successfully.',
        successPass: 'Approved successfully.',
        successBack: 'Dismissed successfully.',
        successRefuse: 'Veto successfully.',
        success: 'Operate successfully.'
    }
};
